import React from 'react';
import PropTypes from 'prop-types';

const NotificationRenderer = ({
    config,
    render,
    topicId,
}) => {

    const configNotification = config.notification ?? {};
    const excludedTopics = configNotification.excludedTopics ?? [];
    const enabled = configNotification.enabled ?? false;

    const id = configNotification.id;
    const shouldShow = enabled && id && !(excludedTopics.some((topic) => topic === topicId));

    if (!shouldShow) {

        return null;

    }

    return render(id, configNotification[id]);

};

NotificationRenderer.propTypes = {
    config: PropTypes.object.isRequired,
    render: PropTypes.func.isRequired,
    topicId: PropTypes.string,
};

NotificationRenderer.defaultProps = {
    topicId: '',
};

export default NotificationRenderer;
